import { ENV } from '../../../config';

export const USER_ADMIN_ROUTER = {
    list: `${ENV.apiUrl}/api/v1/admin/user`,
};
